<template>
	<div class="flex flex_ju_sb flex_a_c global-title" :style="styles">
		<div>
			<span class="font_16 c_45 bold">{{ titles }}</span>
			<!-- 插槽处理 -->
			<slot name="other"></slot>
		</div>

		<span v-if="slotTitle" class="font_14 c_six cursor">{{ slotTitle }}</span>
		<!-- 插槽处理，用于右边的自定义 -->
		<slot></slot>
	</div>
</template>

<script>
/**
 * @description 公共title组件
 * @param titles [String]  左边的主title
 * @param slotTitle [String] 右边的title, 非必有
 * @param widths [String] 宽度, 非必有，建议填充
 * @param heights [String|Number] 高度, 非必有，建议填充，px
 * @param paddings [String] 内间距, 非必有
 * @param isBorder [Boolean] 是否显示底部边框线, 非必有
 */
export default {
	props: {
		// 左边的title
		titles: {
			type: String,
			default: '',
		},
		// 右边的title,非必有项
		slotTitle: {
			type: String,
			default: '',
		},
		widths: {
			type: String,
			default: '100%',
		},
		heights: {
			type: String,
			default: '60',
		},
		paddings: {
			type: String,
			default: '0 0.25rem 0 0.19rem',
		},
		isBorder: {
			type: Boolean,
			default: true,
		},
	},
	computed: {
		styles() {
			let thisHeight
			let borders
			if (Number(this.heights) > 0) {
				thisHeight = (Number(this.heights) / 80).toFixed(2)
			} else {
				thisHeight = this.heights
			}
			if (this.isBorder) {
				borders = '1px solid #f1f1f1'
			} else {
				borders = '1px solid transparent'
			}
			let params = {
				width: this.widths,
				height: thisHeight + 'rem',
				padding: this.paddings,
				'border-bottom': borders,
			}
			// if (this.isBorder) {
			// 	params.borderBottom = '1px solid #f1f1f1'
			// }
			return params
		},
	},
}
</script>

<style lang="scss">
.global-title {
	height: 0.75rem;
	// border-bottom: 1px solid #f1f1f1;
	margin: 0 auto;
}
</style>
